import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-digital-incubator',
  templateUrl: './digital-incubator.component.html',
  styleUrls: ['./digital-incubator.component.css']
})
export class DigitalIncubatorComponent implements OnInit {

  public language: string = sessionStorage.getItem("language");

  constructor() { }

  ngOnInit(): void {
  }

}
